import { useEffect } from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import classNames from 'classnames'

import { getUserData } from '../../../../redux/actions'

import { getGameCards, getTeamCard, getTournamentCard } from '../../const'

import {
  GamesRow,
  StatisticsRow,
  TeamsRow,
  TournamentsRow,
} from '../../../../components/profile-bricks'
import { Button, InnerBox, ProgressCircle } from '../../../../components/UI'
import GameSwitcher from '../../../../components/game-switcher'

import Styled, { StyledRow } from '../../style'
import styles from '../top/styles.module.scss'
import { getStatisticCard } from './utils'
import {
  useUserGames,
  useUserTeams,
  useUserTournaments,
  useUserRating,
  useGameSelection,
  useNavigation,
} from './hooks'

const Bottom = ({ history, isCreator, id }) => {
  const { games, userPublicGames, requestSuccess } = useUserGames(id)

  const {
    teams,
    setTeamFilter,
    requestSuccess: teamsRequestSuccess,
  } = useUserTeams(id)

  const { userTournaments, requestSuccess: tournamentsRequestSuccess } =
    useUserTournaments(id)

  const {
    selectedGame,
    selectedGameStorageFilter,
    onGameChange,
    gamesAvailable,
  } = useGameSelection(games, userPublicGames, isCreator)

  const { rating } = useUserRating(id, userPublicGames, selectedGame)

  const { goToUrl } = useNavigation(selectedGameStorageFilter)

  useEffect(() => {
    getUserData()
  }, [])

  return (
    <div>
      <div className={classNames('contentBoxColor', styles.contentBox)}>
        <GamesRow
          title={
            isCreator() ? (
              <FormattedMessage id='id.myGames' />
            ) : (
              <FormattedMessage id='id.games' />
            )
          }
          cards={
            isCreator()
              ? getGameCards(games, history, isCreator())
              : getGameCards(userPublicGames, history, isCreator())
          }
          requestSuccess={requestSuccess}
        />
      </div>
      <div className={classNames('contentBoxColor', styles.contentBox)}>
        <TeamsRow
          title={
            isCreator() ? (
              <FormattedMessage id='more.myTeams' />
            ) : (
              <FormattedMessage id='navigation.teams' />
            )
          }
          teamRolesOwner={<FormattedMessage id='id.owner' />}
          teamRolesMember={<FormattedMessage id='id.member' />}
          setTeamFilter={setTeamFilter}
          requestSuccess={teamsRequestSuccess}
          cards={getTeamCard(teams, history, isCreator())}
        />
      </div>

      <div className={classNames('contentBoxColor', styles.contentBox)}>
        <TournamentsRow
          title={
            isCreator() ? (
              <FormattedMessage id='id.myTournaments' />
            ) : (
              <FormattedMessage id='id.tournaments' />
            )
          }
          requestSuccess={tournamentsRequestSuccess}
          cards={getTournamentCard(userTournaments, history, isCreator())}
        />
      </div>

      {!!isCreator() && (
        <div className={classNames('contentBoxColor', styles.contentBox)}>
          <StatisticsRow
            title='Followed'
            requestSuccess={requestSuccess}
            cards={getStatisticCard(history)}
          />
        </div>
      )}
      <div className={classNames('contentBoxColor', styles.contentBox)}>
        <StyledRow>
          <section>
            <h1>
              <FormattedMessage id='id.performance' />
            </h1>
            <GameSwitcher
              selectedGame={selectedGame}
              gamesAvailable={gamesAvailable}
              setSelectedGame={onGameChange}
            />
          </section>
          <div style={{ marginTop: '20px' }}>
            <Styled.PerformanceGrid>
              <Styled.PerformanceCard
                className='matches'
                onClick={() => goToUrl('/watch')}
                style={{ cursor: 'pointer' }}
              >
                <div className='metric-label'>
                  <FormattedMessage id='id.performance.game.matches' />
                </div>
                <div className='metric-value'>{rating?.matches || '0'}</div>
              </Styled.PerformanceCard>

              <Styled.PerformanceCard className='wins non-clickable'>
                <div className='metric-label'>
                  <FormattedMessage id='id.performance.wins' />
                </div>
                <div className='metric-value'>{rating?.win || '0'}</div>
              </Styled.PerformanceCard>

              <Styled.PerformanceCard className='defeats non-clickable'>
                <div className='metric-label'>
                  <FormattedMessage id='id.performance.defeats' />
                </div>
                <div className='metric-value'>{rating?.lose || '0'}</div>
              </Styled.PerformanceCard>

              <Styled.PerformanceCard className='draw non-clickable'>
                <div className='metric-label'>Draw</div>
                <div className='metric-value'>{rating?.draw || '0'}</div>
              </Styled.PerformanceCard>

              <Styled.PerformanceCard className='no-show non-clickable'>
                <div className='metric-label'>No Show</div>
                <div className='metric-value'>{rating?.noShow || '0'}</div>
              </Styled.PerformanceCard>
            </Styled.PerformanceGrid>
            <Styled.PerformanceControls>
              <div style={{ margin: '20px 20px ' }}>
                <Button
                  label={<FormattedMessage id='id.performance.seeInRating' />}
                  action={() => history.push(`/rating`)}
                />
              </div>
            </Styled.PerformanceControls>
          </div>
        </StyledRow>
      </div>
      <div className={classNames('contentBoxColor', styles.contentBox)}>
        <StyledRow>
          <section>
            <h1>Game Statistics</h1>
            <GameSwitcher
              selectedGame={selectedGame}
              gamesAvailable={gamesAvailable}
              setSelectedGame={onGameChange}
            />
          </section>
        </StyledRow>
        <Styled.ProgressRow>
          <Styled.ProgressCol>
            <InnerBox>
              <Styled.ProgressTitle>No Show Ratio</Styled.ProgressTitle>
              <ProgressCircle
                value={
                  Math.floor((rating?.noShow / rating?.matches) * 100) || 0
                }
              />
            </InnerBox>
          </Styled.ProgressCol>

          <Styled.ProgressCol>
            <InnerBox>
              <Styled.ProgressTitle>
                <FormattedMessage id='id.performance.dota.winRate' />
              </Styled.ProgressTitle>
              <ProgressCircle
                value={Math.floor((rating?.win / rating?.matches) * 100) || 0}
              />
            </InnerBox>
          </Styled.ProgressCol>
        </Styled.ProgressRow>
      </div>
    </div>
  )
}

const mapStateToProps = state => {
  return {
    userData: state.userData,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    runGetUserData: () => dispatch(getUserData()),
  }
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(Bottom))
